export default "/assets/c1613f2f30544349.svg"